import { FC, JSX, useMemo } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import ContentSliderSlide from './slide';
import { DiscoverProps, ContentSliderSlideProps } from './types';
import Subtitle from 'components/commercetools-ui/atoms/subtitle';
import Slider from 'components/commercetools-ui/atoms/slider';
import { breakpoints } from 'helpers/utils/breakpoints';
import {
  desktop,
  hugeDesktop,
  largeDesktop,
  mediumDesktop,
  mobile,
  tablet,
} from 'helpers/utils/screensizes';

const Discover: FC<DiscoverProps> = ({ data }) => {
  const [isTabletSize] = useMediaQuery(tablet);

  const { isTouchDevice } = useTouchDevice();

  const slidesElement = useMemo(
    () => data?.card_header_button_section?.map((slide: JSX.IntrinsicAttributes & ContentSliderSlideProps, index: string | number | null | undefined) =>
      <ContentSliderSlide key={index} {...slide} />),
    [data?.card_header_button_section],
  );

  const cmsCssClass = data?.additional_css;
  
  return (
    <div
      className={`discover-section ${cmsCssClass} pb-48 pl-24 pt-48 md:px-28 lg:px-48 xl:px-60 xl:pb-40 xl:pt-60 3xl:px-80 2xl:px-61 2xl:pb-80 2xl:pt-80`}
    >
      {data?.header?.section_title && (
        <Typography
          className="mb-36 text-32 font-medium leading-8 text-[#FFFFFF] md:mb-48 xl:text-32 xl:leading-[2.25rem] 2xl:text-48 2xl:leading-[3.25rem]"
          as="h3"
        >
          {data?.header?.section_title}
        </Typography>
      )}
      <div className="relative w-full">
        <Slider
          dots={isTabletSize}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          allowTouchMove={isTouchDevice}
          nextButtonStyles={{ transform: 'translateY(-150%)', right: '10px' }}
          prevButtonStyles={{ transform: 'translateY(-150%)', left: '10px' }}
          slidesPerView={2.68}
          spaceBetween={16}
          breakpoints={{
            [mobile]: {
              slidesPerView: 3,
              spaceBetween: 16,
              ...(breakpoints[tablet] ?? {}),
            },
            [tablet]: {
              slidesPerView: 3,
              spaceBetween: 16,
              ...(breakpoints[tablet] ?? {}),
            },
            [desktop]: {
              slidesPerView: 3,
              spaceBetween: 16,
              ...(breakpoints[desktop] ?? {}),
            },
            [mediumDesktop]: {
              slidesPerView: 3,
              spaceBetween: 16,
              ...(breakpoints[mediumDesktop] ?? {}),
            },
            [largeDesktop]: {
              slidesPerView: 3,
              spaceBetween: 16,
              ...(breakpoints[largeDesktop] ?? {}),
            },
            [hugeDesktop]: {
              slidesPerView: 3,
              spaceBetween: 16,
              ...(breakpoints[hugeDesktop] ?? {}),
            },
          }}
        >
          {slidesElement}
        </Slider>
      </div>
    </div>
  );
};
export default Discover;

export * from './types';
